import type { ReactNode } from 'react';

export const symbol_line_start: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M170-390q-37.8 0-63.9-26.14t-26.1-64Q80-518 106.1-544t63.9-26q29.09 0 52.54 17Q246-536 255-510h595q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H255q-9 26-32.46 43-23.45 17-52.54 17Z"
		/>
	</svg>
);
